import { render, staticRenderFns } from "./_betting_rules.vue?vue&type=template&id=6aa3df54&lang=pug&"
import script from "./_betting_rules.vue?vue&type=script&lang=js&"
export * from "./_betting_rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports